var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-spinner"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Loading..."}}),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.message))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }